export default {
    comingSoon: "בקרוב",
    backHome: "חזרה לדף הבית",
    pages: {
        about: "אודות",
        signUp: "יצירת חשבון",
        forgotPassword: "שכחתי סיסמה",
        resetPassword: "איפוס סיסמה",
        resetPasswordSent: "קישור איפוס נשלח",
        confirmEmail: "אישור אימייל",
        userSetup: "הגדרת חשבון",
        myCart: "העגלה שלי",
        accountSettings: "הגדרות חשבון",
        productsList: "מוצרים",
        productDetails: "פרטי מוצר",
        shippingDetails: "פרטי משלוח",
        shippingAddresses: "כתובות משלוח",
        shippingAddressNew: "כתובת משלוח חדשה",
        shippingAddressEdit: "עריכת כתובת משלוח",
        myOrders: "ההזמנות שלי",
        orderDetails: "פרטי הזמנה",
        orderConfirmation: "אישור הזמנה",
        payment: "תשלום",
        categories: "קטגוריות",
        notifications: "התראות",
        notFound: "העמוד לא נמצא"
    }
} as const;
